import FavoritesDetailView from 'components/views/FavoritesDetailView';
import { getRessourcesForCluster } from 'components/views/FavoritesView/ressource';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
	actionCreators as favoritesAC,
	getIsFavorite,
	getSelectedFavorite,
	getTotalFavoriteCount,
} from 'store/favorites';
import { actionCreators as layoutAC } from 'store/layout';
import { getIsAuthenticated } from 'store/login';
import { getHasUserBeenLoaded, getUserData } from 'store/profile';
import { HistoryType, MatchType } from 'types/withRouter';

export type FavoritesDetailViewContainerProps = {
	history: HistoryType;
	match: MatchType & {
		params: {
			type: string;
			id: string;
		};
	};
};

function getCluster(props): string {
	const cluster = props.match ? props.match.params.type || '' : '';
	return getRessourcesForCluster(cluster).id;
}

export const mapStateToProps = (state, props: FavoritesDetailViewContainerProps) => {
	return {
		contentTypeExternalId: props.match.params.id,
		isAuthenticated: getIsAuthenticated(state),
		isUserLoaded: getHasUserBeenLoaded(state),
		userData: getUserData(state),
		data: getSelectedFavorite(state, props.match.params.id),
		type: getCluster(props),
		favorite: getIsFavorite(state, props.match.params.id),
		total: getTotalFavoriteCount(state),
	};
};

export const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doLockBody: layoutAC.doLockBody,
			doLoadSelectedFavoriteData: favoritesAC.doLoadSelectedFavoriteData,
		},
		dispatch
	);
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default withRouter((connector as any)(FavoritesDetailView));
